import { render, staticRenderFns } from "./ReviewCreated.vue?vue&type=template&id=125df073&scoped=true&"
import script from "./ReviewCreated.vue?vue&type=script&lang=js&"
export * from "./ReviewCreated.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCreated.vue?vue&type=style&index=0&id=125df073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125df073",
  null
  
)

export default component.exports